import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BlockScalar: any;
  ISO8601DateTime: any;
  JsonScalar: any;
};

export type AboutpageComponent = {
  __typename?: 'AboutpageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  features_bar?: Maybe<Scalars['BlockScalar']>;
  image?: Maybe<Asset>;
  investors?: Maybe<Scalars['BlockScalar']>;
  investors_kicker?: Maybe<Scalars['String']>;
  investors_title?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Story>;
  seo?: Maybe<Scalars['JsonScalar']>;
  team?: Maybe<Array<Maybe<Story>>>;
  team_link?: Maybe<Scalars['String']>;
  team_link_text?: Maybe<Scalars['String']>;
  team_text?: Maybe<Scalars['String']>;
  team_title?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AboutpageComponentNewsletterArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type AboutpageComponentTeamArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
};

export type AboutpageFilterQuery = {
  investors_kicker?: InputMaybe<FilterQueryOperations>;
  investors_title?: InputMaybe<FilterQueryOperations>;
  newsletter?: InputMaybe<FilterQueryOperations>;
  team?: InputMaybe<FilterQueryOperations>;
  team_link?: InputMaybe<FilterQueryOperations>;
  team_link_text?: InputMaybe<FilterQueryOperations>;
  team_text?: InputMaybe<FilterQueryOperations>;
  team_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type AboutpageItem = {
  __typename?: 'AboutpageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<AboutpageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type AboutpageItems = {
  __typename?: 'AboutpageItems';
  items?: Maybe<Array<Maybe<AboutpageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Alternate = {
  __typename?: 'Alternate';
  fullSlug: Scalars['String'];
  id: Scalars['Int'];
  isFolder?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  slug: Scalars['String'];
};

export type AnnouncementbarComponent = {
  __typename?: 'AnnouncementbarComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['BlockScalar']>;
  mobile_text?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type AnnouncementbarFilterQuery = {
  mobile_text?: InputMaybe<FilterQueryOperations>;
  text?: InputMaybe<FilterQueryOperations>;
};

export type AnnouncementbarItem = {
  __typename?: 'AnnouncementbarItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<AnnouncementbarComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type AnnouncementbarItems = {
  __typename?: 'AnnouncementbarItems';
  items?: Maybe<Array<Maybe<AnnouncementbarItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Asset = {
  __typename?: 'Asset';
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  focus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AuthorcardComponent = {
  __typename?: 'AuthorcardComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Asset>;
  position?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

export type AuthorcardFilterQuery = {
  linkedin?: InputMaybe<FilterQueryOperations>;
  name?: InputMaybe<FilterQueryOperations>;
  position?: InputMaybe<FilterQueryOperations>;
  twitter?: InputMaybe<FilterQueryOperations>;
};

export type AuthorcardItem = {
  __typename?: 'AuthorcardItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<AuthorcardComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type AuthorcardItems = {
  __typename?: 'AuthorcardItems';
  items?: Maybe<Array<Maybe<AuthorcardItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BannerComponent = {
  __typename?: 'BannerComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  button?: Maybe<Scalars['String']>;
  button_2?: Maybe<Scalars['String']>;
  button_2_action?: Maybe<Scalars['String']>;
  button_2_icon?: Maybe<Scalars['String']>;
  button_2_link?: Maybe<Link>;
  button_action?: Maybe<Scalars['String']>;
  button_link?: Maybe<Link>;
  button_text?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  form_id?: Maybe<Scalars['String']>;
  form_subtitle?: Maybe<Scalars['String']>;
  form_title?: Maybe<Scalars['String']>;
  form_type?: Maybe<Scalars['String']>;
  privacy_policy?: Maybe<Scalars['JsonScalar']>;
  subtext?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BannerFilterQuery = {
  button?: InputMaybe<FilterQueryOperations>;
  button_2?: InputMaybe<FilterQueryOperations>;
  button_2_action?: InputMaybe<FilterQueryOperations>;
  button_2_icon?: InputMaybe<FilterQueryOperations>;
  button_action?: InputMaybe<FilterQueryOperations>;
  button_text?: InputMaybe<FilterQueryOperations>;
  event?: InputMaybe<FilterQueryOperations>;
  form_id?: InputMaybe<FilterQueryOperations>;
  form_subtitle?: InputMaybe<FilterQueryOperations>;
  form_title?: InputMaybe<FilterQueryOperations>;
  form_type?: InputMaybe<FilterQueryOperations>;
  subtext?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type BannerItem = {
  __typename?: 'BannerItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<BannerComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type BannerItems = {
  __typename?: 'BannerItems';
  items?: Maybe<Array<Maybe<BannerItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BannerguideComponent = {
  __typename?: 'BannerguideComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  button?: Maybe<Scalars['String']>;
  button_link?: Maybe<Link>;
  component?: Maybe<Scalars['String']>;
  kicker?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BannerguideFilterQuery = {
  button?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type BannerguideItem = {
  __typename?: 'BannerguideItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<BannerguideComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type BannerguideItems = {
  __typename?: 'BannerguideItems';
  items?: Maybe<Array<Maybe<BannerguideItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BannersimpleComponent = {
  __typename?: 'BannersimpleComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  background_color?: Maybe<Scalars['String']>;
  background_graphic?: Maybe<Scalars['Boolean']>;
  button_label?: Maybe<Scalars['String']>;
  button_link?: Maybe<Link>;
  component?: Maybe<Scalars['String']>;
  layout?: Maybe<Scalars['String']>;
  subtext?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type BannersimpleFilterQuery = {
  background_color?: InputMaybe<FilterQueryOperations>;
  background_graphic?: InputMaybe<FilterQueryOperations>;
  button_label?: InputMaybe<FilterQueryOperations>;
  layout?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type BannersimpleItem = {
  __typename?: 'BannersimpleItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<BannersimpleComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type BannersimpleItems = {
  __typename?: 'BannersimpleItems';
  items?: Maybe<Array<Maybe<BannersimpleItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BlogoverviewComponent = {
  __typename?: 'BlogoverviewComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner_first?: Maybe<Story>;
  banner_last?: Maybe<Story>;
  component?: Maybe<Scalars['String']>;
  featured_post?: Maybe<Story>;
  latest_articles_title?: Maybe<Scalars['String']>;
  more_articles_title?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtitle?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type BlogoverviewComponentBanner_FirstArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type BlogoverviewComponentBanner_LastArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type BlogoverviewComponentFeatured_PostArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type BlogoverviewFilterQuery = {
  banner_first?: InputMaybe<FilterQueryOperations>;
  banner_last?: InputMaybe<FilterQueryOperations>;
  featured_post?: InputMaybe<FilterQueryOperations>;
  latest_articles_title?: InputMaybe<FilterQueryOperations>;
  more_articles_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type BlogoverviewItem = {
  __typename?: 'BlogoverviewItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<BlogoverviewComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type BlogoverviewItems = {
  __typename?: 'BlogoverviewItems';
  items?: Maybe<Array<Maybe<BlogoverviewItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BlogpostComponent = {
  __typename?: 'BlogpostComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  author?: Maybe<Story>;
  banner?: Maybe<Story>;
  body?: Maybe<Scalars['BlockScalar']>;
  category?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  get_content?: Maybe<Scalars['String']>;
  manual_content?: Maybe<Scalars['BlockScalar']>;
  related_articles?: Maybe<Array<Maybe<Story>>>;
  seo?: Maybe<Scalars['JsonScalar']>;
  synopsis?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Asset>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BlogpostComponentAuthorArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type BlogpostComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type BlogpostComponentRelated_ArticlesArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
};

export type BlogpostFilterQuery = {
  author?: InputMaybe<FilterQueryOperations>;
  banner?: InputMaybe<FilterQueryOperations>;
  category?: InputMaybe<FilterQueryOperations>;
  get_content?: InputMaybe<FilterQueryOperations>;
  related_articles?: InputMaybe<FilterQueryOperations>;
  synopsis?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
  type?: InputMaybe<FilterQueryOperations>;
};

export type BlogpostItem = {
  __typename?: 'BlogpostItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<BlogpostComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type BlogpostItems = {
  __typename?: 'BlogpostItems';
  items?: Maybe<Array<Maybe<BlogpostItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type CareersoverviewComponent = {
  __typename?: 'CareersoverviewComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  apply_button?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  button_text?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  faq?: Maybe<Scalars['BlockScalar']>;
  faq_kicker?: Maybe<Scalars['String']>;
  faq_title?: Maybe<Scalars['String']>;
  gallery?: Maybe<Array<Maybe<Asset>>>;
  kicker?: Maybe<Scalars['String']>;
  perks?: Maybe<Scalars['BlockScalar']>;
  perks_kicker?: Maybe<Scalars['String']>;
  perks_title?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
  vacancies?: Maybe<Scalars['BlockScalar']>;
  vacancies_kicker?: Maybe<Scalars['String']>;
  vacancies_title?: Maybe<Scalars['String']>;
};

export type CareersoverviewComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type CareersoverviewFilterQuery = {
  apply_button?: InputMaybe<FilterQueryOperations>;
  banner?: InputMaybe<FilterQueryOperations>;
  button_text?: InputMaybe<FilterQueryOperations>;
  description?: InputMaybe<FilterQueryOperations>;
  faq_kicker?: InputMaybe<FilterQueryOperations>;
  faq_title?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  perks_kicker?: InputMaybe<FilterQueryOperations>;
  perks_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
  vacancies_kicker?: InputMaybe<FilterQueryOperations>;
  vacancies_title?: InputMaybe<FilterQueryOperations>;
};

export type CareersoverviewItem = {
  __typename?: 'CareersoverviewItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<CareersoverviewComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type CareersoverviewItems = {
  __typename?: 'CareersoverviewItems';
  items?: Maybe<Array<Maybe<CareersoverviewItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ContactComponent = {
  __typename?: 'ContactComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  component?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type ContactComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type ContactFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  description?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type ContactItem = {
  __typename?: 'ContactItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<ContactComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ContactItems = {
  __typename?: 'ContactItems';
  items?: Maybe<Array<Maybe<ContactItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ContentItem = {
  __typename?: 'ContentItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<Scalars['JsonScalar']>;
  content_string?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ContentItems = {
  __typename?: 'ContentItems';
  items?: Maybe<Array<Maybe<ContentItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type CookiebannerComponent = {
  __typename?: 'CookiebannerComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  accept_button?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  decline_button?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type CookiebannerFilterQuery = {
  accept_button?: InputMaybe<FilterQueryOperations>;
  decline_button?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type CookiebannerItem = {
  __typename?: 'CookiebannerItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<CookiebannerComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type CookiebannerItems = {
  __typename?: 'CookiebannerItems';
  items?: Maybe<Array<Maybe<CookiebannerItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type CustomeroverviewComponent = {
  __typename?: 'CustomeroverviewComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['BlockScalar']>;
  button_text?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  cta_customers?: Maybe<Scalars['String']>;
  cta_text?: Maybe<Scalars['String']>;
  featured_stories?: Maybe<Array<Maybe<Story>>>;
  kicker?: Maybe<Scalars['String']>;
  list_title?: Maybe<Scalars['String']>;
  logo_section?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CustomeroverviewComponentFeatured_StoriesArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
};

export type CustomeroverviewFilterQuery = {
  button_text?: InputMaybe<FilterQueryOperations>;
  cta_customers?: InputMaybe<FilterQueryOperations>;
  cta_text?: InputMaybe<FilterQueryOperations>;
  featured_stories?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  list_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type CustomeroverviewItem = {
  __typename?: 'CustomeroverviewItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<CustomeroverviewComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type CustomeroverviewItems = {
  __typename?: 'CustomeroverviewItems';
  items?: Maybe<Array<Maybe<CustomeroverviewItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type CustomerstoryComponent = {
  __typename?: 'CustomerstoryComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  body?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  get_content?: Maybe<Scalars['String']>;
  header_text?: Maybe<Scalars['JsonScalar']>;
  image?: Maybe<Asset>;
  image_mobile?: Maybe<Asset>;
  logo?: Maybe<Asset>;
  manual_content?: Maybe<Scalars['BlockScalar']>;
  overview_image?: Maybe<Asset>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtext?: Maybe<Scalars['JsonScalar']>;
  summary?: Maybe<Scalars['BlockScalar']>;
  synopsis?: Maybe<Scalars['String']>;
  thumb_logo?: Maybe<Asset>;
  thumbnail?: Maybe<Asset>;
  title?: Maybe<Scalars['String']>;
};

export type CustomerstoryComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type CustomerstoryFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  get_content?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type CustomerstoryItem = {
  __typename?: 'CustomerstoryItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<CustomerstoryComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type CustomerstoryItems = {
  __typename?: 'CustomerstoryItems';
  items?: Maybe<Array<Maybe<CustomerstoryItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Datasource = {
  __typename?: 'Datasource';
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type DatasourceEntries = {
  __typename?: 'DatasourceEntries';
  items: Array<DatasourceEntry>;
  total: Scalars['Int'];
};

export type DatasourceEntry = {
  __typename?: 'DatasourceEntry';
  dimensionValue?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Datasources = {
  __typename?: 'Datasources';
  items: Array<Datasource>;
};

export type DocsarticleComponent = {
  __typename?: 'DocsarticleComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['BlockScalar']>;
  bottom_links?: Maybe<Story>;
  component?: Maybe<Scalars['String']>;
  get_content?: Maybe<Scalars['String']>;
  manual_content?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtext?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type DocsarticleComponentBottom_LinksArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type DocsarticleFilterQuery = {
  bottom_links?: InputMaybe<FilterQueryOperations>;
  get_content?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type DocsarticleItem = {
  __typename?: 'DocsarticleItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<DocsarticleComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type DocsarticleItems = {
  __typename?: 'DocsarticleItems';
  items?: Maybe<Array<Maybe<DocsarticleItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type DocslandingComponent = {
  __typename?: 'DocslandingComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  cards?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
};

export type DocslandingItem = {
  __typename?: 'DocslandingItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<DocslandingComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type DocslandingItems = {
  __typename?: 'DocslandingItems';
  items?: Maybe<Array<Maybe<DocslandingItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type DocslinksComponent = {
  __typename?: 'DocslinksComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  links?: Maybe<Scalars['BlockScalar']>;
};

export type DocslinksItem = {
  __typename?: 'DocslinksItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<DocslinksComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type DocslinksItems = {
  __typename?: 'DocslinksItems';
  items?: Maybe<Array<Maybe<DocslinksItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FaqComponent = {
  __typename?: 'FaqComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  kicker?: Maybe<Scalars['String']>;
  questions?: Maybe<Scalars['BlockScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type FaqFilterQuery = {
  kicker?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type FaqItem = {
  __typename?: 'FaqItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<FaqComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type FaqItems = {
  __typename?: 'FaqItems';
  items?: Maybe<Array<Maybe<FaqItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FeaturebannerComponent = {
  __typename?: 'FeaturebannerComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  button?: Maybe<Scalars['String']>;
  button_2?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  features?: Maybe<Scalars['BlockScalar']>;
  link?: Maybe<Link>;
  link_2?: Maybe<Link>;
  title?: Maybe<Scalars['String']>;
};

export type FeaturebannerFilterQuery = {
  button?: InputMaybe<FilterQueryOperations>;
  button_2?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type FeaturebannerItem = {
  __typename?: 'FeaturebannerItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<FeaturebannerComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type FeaturebannerItems = {
  __typename?: 'FeaturebannerItems';
  items?: Maybe<Array<Maybe<FeaturebannerItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FilterQueryOperations = {
  /** Must match all values of given array */
  all_in_array?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than date (Exmples: 2019-03-03 or 2020-03-03T03:03:03) */
  gt_date?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Greater than float value */
  gt_float?: InputMaybe<Scalars['Float']>;
  /** Greater than integer value */
  gt_int?: InputMaybe<Scalars['Int']>;
  /** Matches exactly one value */
  in?: InputMaybe<Scalars['String']>;
  /** Matches any value of given array */
  in_array?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Matches exactly one integer value */
  in_int?: InputMaybe<Scalars['Int']>;
  /** Matches exactly one value with a wildcard search using * */
  like?: InputMaybe<Scalars['String']>;
  /** Less than date (Format: 2019-03-03 or 2020-03-03T03:03:03) */
  lt_date?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Less than float value */
  lt_float?: InputMaybe<Scalars['Float']>;
  /** Less than integer value */
  lt_int?: InputMaybe<Scalars['Int']>;
  /** Matches all without the given value */
  not_in?: InputMaybe<Scalars['String']>;
  /** Matches all without the given value */
  not_like?: InputMaybe<Scalars['String']>;
};

export type FooterComponent = {
  __typename?: 'FooterComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  bottom_links?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  github?: Maybe<Link>;
  instagram?: Maybe<Link>;
  link_columns?: Maybe<Scalars['BlockScalar']>;
  linkedin?: Maybe<Link>;
  top_links?: Maybe<Scalars['BlockScalar']>;
  twitter?: Maybe<Link>;
};

export type FooterFilterQuery = {
  description?: InputMaybe<FilterQueryOperations>;
};

export type FooterItem = {
  __typename?: 'FooterItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<FooterComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type FooterItems = {
  __typename?: 'FooterItems';
  items?: Maybe<Array<Maybe<FooterItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type GuidechapterComponent = {
  __typename?: 'GuidechapterComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  body?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  get_content?: Maybe<Scalars['String']>;
  manual_content?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  short_title?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type GuidechapterComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type GuidechapterFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  get_content?: InputMaybe<FilterQueryOperations>;
  short_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type GuidechapterItem = {
  __typename?: 'GuidechapterItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<GuidechapterComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type GuidechapterItems = {
  __typename?: 'GuidechapterItems';
  items?: Maybe<Array<Maybe<GuidechapterItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type GuideindexComponent = {
  __typename?: 'GuideindexComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  body?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  faq?: Maybe<Scalars['BlockScalar']>;
  faq_kicker?: Maybe<Scalars['String']>;
  faq_title?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type GuideindexComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type GuideindexFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  faq_kicker?: InputMaybe<FilterQueryOperations>;
  faq_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type GuideindexItem = {
  __typename?: 'GuideindexItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<GuideindexComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type GuideindexItems = {
  __typename?: 'GuideindexItems';
  items?: Maybe<Array<Maybe<GuideindexItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type HomeComponent = {
  __typename?: 'HomeComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  animation_1?: Maybe<Asset>;
  animation_1_description?: Maybe<Scalars['JsonScalar']>;
  animation_1_title?: Maybe<Scalars['String']>;
  animation_2?: Maybe<Asset>;
  animation_2_description?: Maybe<Scalars['JsonScalar']>;
  animation_2_title?: Maybe<Scalars['String']>;
  banner_first?: Maybe<Story>;
  banner_last?: Maybe<Story>;
  button_1?: Maybe<Scalars['String']>;
  button_1_link?: Maybe<Link>;
  button_2?: Maybe<Scalars['String']>;
  button_2_link?: Maybe<Link>;
  cards?: Maybe<Scalars['BlockScalar']>;
  cards_title?: Maybe<Scalars['JsonScalar']>;
  component?: Maybe<Scalars['String']>;
  customer_button?: Maybe<Scalars['String']>;
  customer_image?: Maybe<Asset>;
  customer_link?: Maybe<Link>;
  customer_logo?: Maybe<Asset>;
  customer_results?: Maybe<Scalars['BlockScalar']>;
  customer_subtitle?: Maybe<Scalars['String']>;
  customer_title?: Maybe<Scalars['JsonScalar']>;
  data?: Maybe<Scalars['BlockScalar']>;
  data_subtitle?: Maybe<Scalars['String']>;
  data_title?: Maybe<Scalars['JsonScalar']>;
  feat_1?: Maybe<Scalars['String']>;
  feat_2?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  logo_section?: Maybe<Scalars['BlockScalar']>;
  scroll_cards?: Maybe<Scalars['BlockScalar']>;
  scroll_subtitle?: Maybe<Scalars['String']>;
  scroll_title?: Maybe<Scalars['JsonScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtext?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JsonScalar']>;
};

export type HomeComponentBanner_FirstArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type HomeComponentBanner_LastArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type HomeFilterQuery = {
  animation_1_title?: InputMaybe<FilterQueryOperations>;
  animation_2_title?: InputMaybe<FilterQueryOperations>;
  banner_first?: InputMaybe<FilterQueryOperations>;
  banner_last?: InputMaybe<FilterQueryOperations>;
  button_1?: InputMaybe<FilterQueryOperations>;
  button_2?: InputMaybe<FilterQueryOperations>;
  customer_button?: InputMaybe<FilterQueryOperations>;
  feat_1?: InputMaybe<FilterQueryOperations>;
  feat_2?: InputMaybe<FilterQueryOperations>;
};

export type HomeItem = {
  __typename?: 'HomeItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<HomeComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type HomeItems = {
  __typename?: 'HomeItems';
  items?: Maybe<Array<Maybe<HomeItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type IntegrationspageComponent = {
  __typename?: 'IntegrationspageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  button?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  integrations?: Maybe<Scalars['BlockScalar']>;
  kicker?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type IntegrationspageComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type IntegrationspageFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  button?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type IntegrationspageItem = {
  __typename?: 'IntegrationspageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<IntegrationspageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type IntegrationspageItems = {
  __typename?: 'IntegrationspageItems';
  items?: Maybe<Array<Maybe<IntegrationspageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type LandingsettingsComponent = {
  __typename?: 'LandingsettingsComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  footer?: Maybe<Scalars['BlockScalar']>;
  link_logo?: Maybe<Scalars['Boolean']>;
};

export type LandingsettingsFilterQuery = {
  link_logo?: InputMaybe<FilterQueryOperations>;
};

export type LandingsettingsItem = {
  __typename?: 'LandingsettingsItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<LandingsettingsComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type LandingsettingsItems = {
  __typename?: 'LandingsettingsItems';
  items?: Maybe<Array<Maybe<LandingsettingsItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Link = {
  __typename?: 'Link';
  cachedUrl: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  fieldtype: Scalars['String'];
  id: Scalars['String'];
  linktype: Scalars['String'];
  story?: Maybe<Story>;
  url: Scalars['String'];
};

export type LinkEntries = {
  __typename?: 'LinkEntries';
  items: Array<LinkEntry>;
};

export type LinkEntry = {
  __typename?: 'LinkEntry';
  id?: Maybe<Scalars['Int']>;
  isFolder?: Maybe<Scalars['Boolean']>;
  isStartpage?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type NavigationComponent = {
  __typename?: 'NavigationComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  button_1_label?: Maybe<Scalars['String']>;
  button_1_url?: Maybe<Link>;
  button_2_label?: Maybe<Scalars['String']>;
  button_2_url?: Maybe<Link>;
  component?: Maybe<Scalars['String']>;
  links?: Maybe<Scalars['BlockScalar']>;
};

export type NavigationFilterQuery = {
  button_1_label?: InputMaybe<FilterQueryOperations>;
  button_2_label?: InputMaybe<FilterQueryOperations>;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<NavigationComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type NavigationItems = {
  __typename?: 'NavigationItems';
  items?: Maybe<Array<Maybe<NavigationItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type NewsletterComponent = {
  __typename?: 'NewsletterComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  button_label?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type NewsletterFilterQuery = {
  button_label?: InputMaybe<FilterQueryOperations>;
  disclaimer?: InputMaybe<FilterQueryOperations>;
  subtitle?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type NewsletterItem = {
  __typename?: 'NewsletterItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<NewsletterComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type NewsletterItems = {
  __typename?: 'NewsletterItems';
  items?: Maybe<Array<Maybe<NewsletterItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type NewsletterbannersimpleComponent = {
  __typename?: 'NewsletterbannersimpleComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  button?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type NewsletterbannersimpleFilterQuery = {
  button?: InputMaybe<FilterQueryOperations>;
  number?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type NewsletterbannersimpleItem = {
  __typename?: 'NewsletterbannersimpleItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<NewsletterbannersimpleComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type NewsletterbannersimpleItems = {
  __typename?: 'NewsletterbannersimpleItems';
  items?: Maybe<Array<Maybe<NewsletterbannersimpleItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type OnboardingComponent = {
  __typename?: 'OnboardingComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  email_placeholder?: Maybe<Scalars['String']>;
  email_question?: Maybe<Scalars['String']>;
  email_subtext?: Maybe<Scalars['String']>;
  email_title?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  findus_question?: Maybe<Scalars['String']>;
  findus_subtext?: Maybe<Scalars['String']>;
  findus_title?: Maybe<Scalars['String']>;
  formType?: Maybe<Scalars['String']>;
  marketing_comms?: Maybe<Scalars['String']>;
  organisation_error?: Maybe<Scalars['JsonScalar']>;
  organisation_features?: Maybe<Scalars['BlockScalar']>;
  organisation_placeholder?: Maybe<Scalars['String']>;
  organisation_question?: Maybe<Scalars['String']>;
  organisation_quote?: Maybe<Scalars['BlockScalar']>;
  organisation_subtext?: Maybe<Scalars['String']>;
  organisation_title?: Maybe<Scalars['String']>;
  privacy_policy?: Maybe<Scalars['JsonScalar']>;
  role_question?: Maybe<Scalars['String']>;
  role_subtext?: Maybe<Scalars['String']>;
  role_title?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  submit_button?: Maybe<Scalars['String']>;
  success_button?: Maybe<Scalars['String']>;
  success_button_link?: Maybe<Link>;
  success_subtext?: Maybe<Scalars['String']>;
  success_title?: Maybe<Scalars['String']>;
  usage_question?: Maybe<Scalars['String']>;
  usage_subtext?: Maybe<Scalars['String']>;
  usage_title?: Maybe<Scalars['String']>;
};

export type OnboardingFilterQuery = {
  email_placeholder?: InputMaybe<FilterQueryOperations>;
  email_question?: InputMaybe<FilterQueryOperations>;
  email_subtext?: InputMaybe<FilterQueryOperations>;
  email_title?: InputMaybe<FilterQueryOperations>;
  event?: InputMaybe<FilterQueryOperations>;
  findus_question?: InputMaybe<FilterQueryOperations>;
  findus_subtext?: InputMaybe<FilterQueryOperations>;
  findus_title?: InputMaybe<FilterQueryOperations>;
  formType?: InputMaybe<FilterQueryOperations>;
  marketing_comms?: InputMaybe<FilterQueryOperations>;
  organisation_placeholder?: InputMaybe<FilterQueryOperations>;
  organisation_question?: InputMaybe<FilterQueryOperations>;
  organisation_subtext?: InputMaybe<FilterQueryOperations>;
  organisation_title?: InputMaybe<FilterQueryOperations>;
  role_question?: InputMaybe<FilterQueryOperations>;
  role_subtext?: InputMaybe<FilterQueryOperations>;
  role_title?: InputMaybe<FilterQueryOperations>;
  submit_button?: InputMaybe<FilterQueryOperations>;
  success_button?: InputMaybe<FilterQueryOperations>;
  success_title?: InputMaybe<FilterQueryOperations>;
  usage_question?: InputMaybe<FilterQueryOperations>;
  usage_subtext?: InputMaybe<FilterQueryOperations>;
  usage_title?: InputMaybe<FilterQueryOperations>;
};

export type OnboardingItem = {
  __typename?: 'OnboardingItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<OnboardingComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type OnboardingItems = {
  __typename?: 'OnboardingItems';
  items?: Maybe<Array<Maybe<OnboardingItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PageComponent = {
  __typename?: 'PageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  body?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
};

export type PageComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type PageFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
};

export type PageItem = {
  __typename?: 'PageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<PageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type PageItems = {
  __typename?: 'PageItems';
  items?: Maybe<Array<Maybe<PageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PartnerpageComponent = {
  __typename?: 'PartnerpageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  button?: Maybe<Scalars['String']>;
  button_2?: Maybe<Scalars['String']>;
  button_2_link?: Maybe<Link>;
  button_action?: Maybe<Scalars['String']>;
  button_link?: Maybe<Link>;
  component?: Maybe<Scalars['String']>;
  logo_section?: Maybe<Scalars['BlockScalar']>;
  modal_form?: Maybe<Scalars['BlockScalar']>;
  partner_form?: Maybe<Scalars['BlockScalar']>;
  scroll_panel?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtext?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PartnerpageComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type PartnerpageFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  button?: InputMaybe<FilterQueryOperations>;
  button_2?: InputMaybe<FilterQueryOperations>;
  button_action?: InputMaybe<FilterQueryOperations>;
  subtext?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type PartnerpageItem = {
  __typename?: 'PartnerpageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<PartnerpageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type PartnerpageItems = {
  __typename?: 'PartnerpageItems';
  items?: Maybe<Array<Maybe<PartnerpageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PressComponent = {
  __typename?: 'PressComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  articles?: Maybe<Scalars['BlockScalar']>;
  banner?: Maybe<Story>;
  component?: Maybe<Scalars['String']>;
  kicker?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtext?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PressComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type PressFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  subtext?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type PressItem = {
  __typename?: 'PressItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<PressComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type PressItems = {
  __typename?: 'PressItems';
  items?: Maybe<Array<Maybe<PressItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PricingComponent = {
  __typename?: 'PricingComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  faq?: Maybe<Scalars['BlockScalar']>;
  faq_kicker?: Maybe<Scalars['String']>;
  faq_title?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Story>;
  pricing_cards?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type PricingComponentNewsletterArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type PricingFilterQuery = {
  faq_kicker?: InputMaybe<FilterQueryOperations>;
  faq_title?: InputMaybe<FilterQueryOperations>;
  newsletter?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type PricingItem = {
  __typename?: 'PricingItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<PricingComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type PricingItems = {
  __typename?: 'PricingItems';
  items?: Maybe<Array<Maybe<PricingItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type QueryType = {
  __typename?: 'QueryType';
  AboutpageItem?: Maybe<AboutpageItem>;
  AboutpageItems?: Maybe<AboutpageItems>;
  AnnouncementbarItem?: Maybe<AnnouncementbarItem>;
  AnnouncementbarItems?: Maybe<AnnouncementbarItems>;
  AuthorcardItem?: Maybe<AuthorcardItem>;
  AuthorcardItems?: Maybe<AuthorcardItems>;
  BannerItem?: Maybe<BannerItem>;
  BannerItems?: Maybe<BannerItems>;
  BannerguideItem?: Maybe<BannerguideItem>;
  BannerguideItems?: Maybe<BannerguideItems>;
  BannersimpleItem?: Maybe<BannersimpleItem>;
  BannersimpleItems?: Maybe<BannersimpleItems>;
  BlogoverviewItem?: Maybe<BlogoverviewItem>;
  BlogoverviewItems?: Maybe<BlogoverviewItems>;
  BlogpostItem?: Maybe<BlogpostItem>;
  BlogpostItems?: Maybe<BlogpostItems>;
  CareersoverviewItem?: Maybe<CareersoverviewItem>;
  CareersoverviewItems?: Maybe<CareersoverviewItems>;
  ContactItem?: Maybe<ContactItem>;
  ContactItems?: Maybe<ContactItems>;
  ContentNode?: Maybe<ContentItem>;
  ContentNodes?: Maybe<ContentItems>;
  CookiebannerItem?: Maybe<CookiebannerItem>;
  CookiebannerItems?: Maybe<CookiebannerItems>;
  CustomeroverviewItem?: Maybe<CustomeroverviewItem>;
  CustomeroverviewItems?: Maybe<CustomeroverviewItems>;
  CustomerstoryItem?: Maybe<CustomerstoryItem>;
  CustomerstoryItems?: Maybe<CustomerstoryItems>;
  DatasourceEntries?: Maybe<DatasourceEntries>;
  Datasources?: Maybe<Datasources>;
  DocsarticleItem?: Maybe<DocsarticleItem>;
  DocsarticleItems?: Maybe<DocsarticleItems>;
  DocslandingItem?: Maybe<DocslandingItem>;
  DocslandingItems?: Maybe<DocslandingItems>;
  DocslinksItem?: Maybe<DocslinksItem>;
  DocslinksItems?: Maybe<DocslinksItems>;
  FaqItem?: Maybe<FaqItem>;
  FaqItems?: Maybe<FaqItems>;
  FeaturebannerItem?: Maybe<FeaturebannerItem>;
  FeaturebannerItems?: Maybe<FeaturebannerItems>;
  FooterItem?: Maybe<FooterItem>;
  FooterItems?: Maybe<FooterItems>;
  GuidechapterItem?: Maybe<GuidechapterItem>;
  GuidechapterItems?: Maybe<GuidechapterItems>;
  GuideindexItem?: Maybe<GuideindexItem>;
  GuideindexItems?: Maybe<GuideindexItems>;
  HomeItem?: Maybe<HomeItem>;
  HomeItems?: Maybe<HomeItems>;
  IntegrationspageItem?: Maybe<IntegrationspageItem>;
  IntegrationspageItems?: Maybe<IntegrationspageItems>;
  LandingsettingsItem?: Maybe<LandingsettingsItem>;
  LandingsettingsItems?: Maybe<LandingsettingsItems>;
  Links?: Maybe<LinkEntries>;
  NavigationItem?: Maybe<NavigationItem>;
  NavigationItems?: Maybe<NavigationItems>;
  NewsletterItem?: Maybe<NewsletterItem>;
  NewsletterItems?: Maybe<NewsletterItems>;
  NewsletterbannersimpleItem?: Maybe<NewsletterbannersimpleItem>;
  NewsletterbannersimpleItems?: Maybe<NewsletterbannersimpleItems>;
  OnboardingItem?: Maybe<OnboardingItem>;
  OnboardingItems?: Maybe<OnboardingItems>;
  PageItem?: Maybe<PageItem>;
  PageItems?: Maybe<PageItems>;
  PartnerpageItem?: Maybe<PartnerpageItem>;
  PartnerpageItems?: Maybe<PartnerpageItems>;
  PressItem?: Maybe<PressItem>;
  PressItems?: Maybe<PressItems>;
  PricingItem?: Maybe<PricingItem>;
  PricingItems?: Maybe<PricingItems>;
  RateLimit?: Maybe<RateLimit>;
  Space?: Maybe<Space>;
  Tags?: Maybe<Tags>;
  VacancypageItem?: Maybe<VacancypageItem>;
  VacancypageItems?: Maybe<VacancypageItems>;
  WebinarItem?: Maybe<WebinarItem>;
  WebinarItems?: Maybe<WebinarItems>;
  WebinaroverviewItem?: Maybe<WebinaroverviewItem>;
  WebinaroverviewItems?: Maybe<WebinaroverviewItems>;
  WebinarrecordedItem?: Maybe<WebinarrecordedItem>;
  WebinarrecordedItems?: Maybe<WebinarrecordedItems>;
  WhitepaperItem?: Maybe<WhitepaperItem>;
  WhitepaperItems?: Maybe<WhitepaperItems>;
  WhitepaperoverviewItem?: Maybe<WhitepaperoverviewItem>;
  WhitepaperoverviewItems?: Maybe<WhitepaperoverviewItems>;
};

export type QueryTypeAboutpageItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeAboutpageItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<AboutpageFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeAnnouncementbarItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeAnnouncementbarItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<AnnouncementbarFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeAuthorcardItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeAuthorcardItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<AuthorcardFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBannerItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBannerItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<BannerFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBannerguideItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBannerguideItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<BannerguideFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBannersimpleItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBannersimpleItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<BannersimpleFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBlogoverviewItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBlogoverviewItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<BlogoverviewFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBlogpostItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeBlogpostItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<BlogpostFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeCareersoverviewItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeCareersoverviewItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<CareersoverviewFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeContactItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeContactItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<ContactFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeContentNodeArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeContentNodesArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeCookiebannerItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeCookiebannerItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<CookiebannerFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeCustomeroverviewItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeCustomeroverviewItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<CustomeroverviewFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeCustomerstoryItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeCustomerstoryItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<CustomerstoryFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeDatasourceEntriesArgs = {
  datasource?: InputMaybe<Scalars['String']>;
  dimension?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
};

export type QueryTypeDatasourcesArgs = {
  by_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryTypeDocsarticleItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeDocsarticleItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<DocsarticleFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeDocslandingItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeDocslandingItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeDocslinksItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeDocslinksItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeFaqItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeFaqItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<FaqFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeFeaturebannerItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeFeaturebannerItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<FeaturebannerFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeFooterItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeFooterItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<FooterFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeGuidechapterItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeGuidechapterItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<GuidechapterFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeGuideindexItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeGuideindexItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<GuideindexFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeHomeItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeHomeItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<HomeFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeIntegrationspageItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeIntegrationspageItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<IntegrationspageFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeLandingsettingsItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeLandingsettingsItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<LandingsettingsFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeLinksArgs = {
  paginated?: InputMaybe<Scalars['Boolean']>;
  starts_with?: InputMaybe<Scalars['String']>;
};

export type QueryTypeNavigationItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeNavigationItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<NavigationFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeNewsletterItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeNewsletterItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<NewsletterFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeNewsletterbannersimpleItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeNewsletterbannersimpleItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<NewsletterbannersimpleFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeOnboardingItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeOnboardingItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<OnboardingFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypePageItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypePageItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<PageFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypePartnerpageItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypePartnerpageItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<PartnerpageFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypePressItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypePressItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<PressFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypePricingItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypePricingItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<PricingFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeTagsArgs = {
  starts_with?: InputMaybe<Scalars['String']>;
};

export type QueryTypeVacancypageItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeVacancypageItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<VacancypageFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWebinarItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWebinarItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<WebinarFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWebinaroverviewItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWebinaroverviewItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<WebinaroverviewFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWebinarrecordedItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWebinarrecordedItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<WebinarrecordedFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWhitepaperItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWhitepaperItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<WhitepaperFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWhitepaperoverviewItemArgs = {
  find_by?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type QueryTypeWhitepaperoverviewItemsArgs = {
  by_slugs?: InputMaybe<Scalars['String']>;
  by_uuids?: InputMaybe<Scalars['String']>;
  by_uuids_ordered?: InputMaybe<Scalars['String']>;
  excluding_fields?: InputMaybe<Scalars['String']>;
  excluding_ids?: InputMaybe<Scalars['String']>;
  excluding_slugs?: InputMaybe<Scalars['String']>;
  fallback_lang?: InputMaybe<Scalars['String']>;
  filter_query?: InputMaybe<Scalars['JsonScalar']>;
  filter_query_v2?: InputMaybe<WhitepaperoverviewFilterQuery>;
  first_published_at_gt?: InputMaybe<Scalars['String']>;
  first_published_at_lt?: InputMaybe<Scalars['String']>;
  from_release?: InputMaybe<Scalars['String']>;
  is_startpage?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per_page?: InputMaybe<Scalars['Int']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  resolve_links?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
  search_term?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
  with_tag?: InputMaybe<Scalars['String']>;
};

export type RateLimit = {
  __typename?: 'RateLimit';
  maxCost: Scalars['Int'];
};

export type Space = {
  __typename?: 'Space';
  domain: Scalars['String'];
  id: Scalars['Int'];
  languageCodes: Array<Maybe<Scalars['String']>>;
  name: Scalars['String'];
  version: Scalars['Int'];
};

export type Story = {
  __typename?: 'Story';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<Scalars['JsonScalar']>;
  createdAt?: Maybe<Scalars['String']>;
  firstPublishedAt?: Maybe<Scalars['String']>;
  fullSlug?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isStartpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  metaData?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['String']>;
  releaseId?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sortByDate?: Maybe<Scalars['String']>;
  tagList?: Maybe<Array<Maybe<Scalars['String']>>>;
  translatedSlugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  name: Scalars['String'];
  taggingsCount: Scalars['Int'];
};

export type Tags = {
  __typename?: 'Tags';
  items: Array<Tag>;
};

export type TranslatedSlug = {
  __typename?: 'TranslatedSlug';
  lang: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type VacancypageComponent = {
  __typename?: 'VacancypageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  apply_box?: Maybe<Scalars['BlockScalar']>;
  banner?: Maybe<Story>;
  body?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  faq?: Maybe<Story>;
  keywords?: Maybe<Scalars['BlockScalar']>;
  kicker?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  short?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type VacancypageComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type VacancypageComponentFaqArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type VacancypageFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  faq?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  short?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type VacancypageItem = {
  __typename?: 'VacancypageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<VacancypageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type VacancypageItems = {
  __typename?: 'VacancypageItems';
  items?: Maybe<Array<Maybe<VacancypageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type WebinarComponent = {
  __typename?: 'WebinarComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['JsonScalar']>;
  button_text?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  extra_info?: Maybe<Scalars['BlockScalar']>;
  formType?: Maybe<Scalars['String']>;
  form_id?: Maybe<Scalars['String']>;
  form_subtext?: Maybe<Scalars['JsonScalar']>;
  form_success_subtext?: Maybe<Scalars['String']>;
  form_success_title?: Maybe<Scalars['String']>;
  form_title?: Maybe<Scalars['String']>;
  hosts?: Maybe<Array<Maybe<Story>>>;
  image?: Maybe<Asset>;
  kicker?: Maybe<Scalars['String']>;
  privacy_policy?: Maybe<Scalars['JsonScalar']>;
  related_events?: Maybe<Array<Maybe<Story>>>;
  related_title?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type WebinarComponentHostsArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
};

export type WebinarComponentRelated_EventsArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
};

export type WebinarFilterQuery = {
  button_text?: InputMaybe<FilterQueryOperations>;
  event?: InputMaybe<FilterQueryOperations>;
  formType?: InputMaybe<FilterQueryOperations>;
  form_id?: InputMaybe<FilterQueryOperations>;
  form_success_title?: InputMaybe<FilterQueryOperations>;
  form_title?: InputMaybe<FilterQueryOperations>;
  hosts?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  related_events?: InputMaybe<FilterQueryOperations>;
  related_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type WebinarItem = {
  __typename?: 'WebinarItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<WebinarComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type WebinarItems = {
  __typename?: 'WebinarItems';
  items?: Maybe<Array<Maybe<WebinarItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type WebinaroverviewComponent = {
  __typename?: 'WebinaroverviewComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner?: Maybe<Story>;
  body?: Maybe<Scalars['BlockScalar']>;
  button_text?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  highlight?: Maybe<Story>;
  highlight_cta?: Maybe<Scalars['String']>;
  highlight_image?: Maybe<Asset>;
  highlight_subtext?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  kicker?: Maybe<Scalars['String']>;
  recorded_title?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  upcoming_cta?: Maybe<Scalars['String']>;
  upcoming_title?: Maybe<Scalars['String']>;
};

export type WebinaroverviewComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type WebinaroverviewComponentHighlightArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type WebinaroverviewFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  button_text?: InputMaybe<FilterQueryOperations>;
  highlight?: InputMaybe<FilterQueryOperations>;
  highlight_cta?: InputMaybe<FilterQueryOperations>;
  highlight_subtext?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  recorded_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
  upcoming_cta?: InputMaybe<FilterQueryOperations>;
  upcoming_title?: InputMaybe<FilterQueryOperations>;
};

export type WebinaroverviewItem = {
  __typename?: 'WebinaroverviewItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<WebinaroverviewComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type WebinaroverviewItems = {
  __typename?: 'WebinaroverviewItems';
  items?: Maybe<Array<Maybe<WebinaroverviewItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type WebinarrecordedComponent = {
  __typename?: 'WebinarrecordedComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['JsonScalar']>;
  banner?: Maybe<Story>;
  body?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  extra_info?: Maybe<Scalars['BlockScalar']>;
  form?: Maybe<Scalars['BlockScalar']>;
  hosts?: Maybe<Array<Maybe<Story>>>;
  image?: Maybe<Asset>;
  kicker?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  related_events?: Maybe<Array<Maybe<Story>>>;
  related_title?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<Link>;
};

export type WebinarrecordedComponentBannerArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type WebinarrecordedComponentHostsArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
};

export type WebinarrecordedComponentRelated_EventsArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  sort_by?: InputMaybe<Scalars['String']>;
};

export type WebinarrecordedFilterQuery = {
  banner?: InputMaybe<FilterQueryOperations>;
  hosts?: InputMaybe<FilterQueryOperations>;
  kicker?: InputMaybe<FilterQueryOperations>;
  label?: InputMaybe<FilterQueryOperations>;
  related_events?: InputMaybe<FilterQueryOperations>;
  related_title?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type WebinarrecordedItem = {
  __typename?: 'WebinarrecordedItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<WebinarrecordedComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type WebinarrecordedItems = {
  __typename?: 'WebinarrecordedItems';
  items?: Maybe<Array<Maybe<WebinarrecordedItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type WhitepaperComponent = {
  __typename?: 'WhitepaperComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  bg_image?: Maybe<Asset>;
  blocks?: Maybe<Scalars['BlockScalar']>;
  button_text?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  formType?: Maybe<Scalars['String']>;
  form_id?: Maybe<Scalars['String']>;
  form_success_subtext?: Maybe<Scalars['String']>;
  form_success_title?: Maybe<Scalars['String']>;
  privacy_policy?: Maybe<Scalars['JsonScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtitle?: Maybe<Scalars['String']>;
  synopsis?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Asset>;
  title?: Maybe<Scalars['String']>;
};

export type WhitepaperFilterQuery = {
  button_text?: InputMaybe<FilterQueryOperations>;
  event?: InputMaybe<FilterQueryOperations>;
  formType?: InputMaybe<FilterQueryOperations>;
  form_id?: InputMaybe<FilterQueryOperations>;
  form_success_subtext?: InputMaybe<FilterQueryOperations>;
  form_success_title?: InputMaybe<FilterQueryOperations>;
  subtitle?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type WhitepaperItem = {
  __typename?: 'WhitepaperItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<WhitepaperComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type WhitepaperItems = {
  __typename?: 'WhitepaperItems';
  items?: Maybe<Array<Maybe<WhitepaperItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type WhitepaperoverviewComponent = {
  __typename?: 'WhitepaperoverviewComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner_first?: Maybe<Story>;
  banner_last?: Maybe<Story>;
  component?: Maybe<Scalars['String']>;
  cta_text?: Maybe<Scalars['String']>;
  featured_whitepaper?: Maybe<Story>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type WhitepaperoverviewComponentBanner_FirstArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type WhitepaperoverviewComponentBanner_LastArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type WhitepaperoverviewComponentFeatured_WhitepaperArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  language?: InputMaybe<Scalars['String']>;
  resolve_relations?: InputMaybe<Scalars['String']>;
};

export type WhitepaperoverviewFilterQuery = {
  banner_first?: InputMaybe<FilterQueryOperations>;
  banner_last?: InputMaybe<FilterQueryOperations>;
  cta_text?: InputMaybe<FilterQueryOperations>;
  featured_whitepaper?: InputMaybe<FilterQueryOperations>;
  title?: InputMaybe<FilterQueryOperations>;
};

export type WhitepaperoverviewItem = {
  __typename?: 'WhitepaperoverviewItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<WhitepaperoverviewComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type WhitepaperoverviewItems = {
  __typename?: 'WhitepaperoverviewItems';
  items?: Maybe<Array<Maybe<WhitepaperoverviewItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ImageFragmentFragment = {
  __typename?: 'Asset';
  alt?: string | null;
  filename: string;
};

export type LinkFragmentFragment = {
  __typename?: 'Link';
  url: string;
  linktype: string;
  story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
};

export type TranslatedSlugsFragmentFragment = {
  __typename?: 'TranslatedSlug';
  lang: string;
  name?: string | null;
  path?: string | null;
};

export type AnnouncementBarItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type AnnouncementBarItemQuery = {
  __typename?: 'QueryType';
  AnnouncementbarItem?: {
    __typename?: 'AnnouncementbarItem';
    uuid?: string | null;
    content?: {
      __typename?: 'AnnouncementbarComponent';
      text?: string | null;
      mobile_text?: string | null;
      link?: any | null;
      component?: string | null;
      _editable?: string | null;
      _uid?: string | null;
    } | null;
  } | null;
};

export type AuthorCardItemsQueryVariables = Exact<{
  filterId?: InputMaybe<Scalars['String']>;
}>;

export type AuthorCardItemsQuery = {
  __typename?: 'QueryType';
  AuthorcardItems?: {
    __typename?: 'AuthorcardItems';
    items?: Array<{
      __typename?: 'AuthorcardItem';
      uuid?: string | null;
      content?: {
        __typename?: 'AuthorcardComponent';
        name?: string | null;
        position?: string | null;
        _uid?: string | null;
        photo?: {
          __typename?: 'Asset';
          alt?: string | null;
          filename: string;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type BlogOverviewItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type BlogOverviewItemQuery = {
  __typename?: 'QueryType';
  BlogoverviewItem?: {
    __typename?: 'BlogoverviewItem';
    uuid?: string | null;
    content?: {
      __typename?: 'BlogoverviewComponent';
      _editable?: string | null;
      _uid?: string | null;
      subtitle?: any | null;
      title?: string | null;
      latest_articles_title?: string | null;
      more_articles_title?: string | null;
      seo?: any | null;
      featured_post?: {
        __typename?: 'Story';
        content?: any | null;
        firstPublishedAt?: string | null;
        slug?: string | null;
        id?: number | null;
      } | null;
      banner_first?: { __typename?: 'Story'; content?: any | null } | null;
      banner_last?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export type BlogPostItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: InputMaybe<Scalars['String']>;
}>;

export type BlogPostItemQuery = {
  __typename?: 'QueryType';
  BlogpostItem?: {
    __typename?: 'BlogpostItem';
    published_at?: string | null;
    first_published_at?: string | null;
    uuid?: string | null;
    default_full_slug?: string | null;
    full_slug?: string | null;
    content?: {
      __typename?: 'BlogpostComponent';
      component?: string | null;
      seo?: any | null;
      title?: string | null;
      body?: any | null;
      get_content?: string | null;
      manual_content?: any | null;
      _uid?: string | null;
      _editable?: string | null;
      thumbnail?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      author?: { __typename?: 'Story'; content?: any | null } | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
      related_articles?: Array<{
        __typename?: 'Story';
        content?: any | null;
        slug?: string | null;
      } | null> | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type BlogPostItemsQueryVariables = Exact<{
  filterId?: InputMaybe<Scalars['String']>;
  filterQuery?: InputMaybe<Scalars['JsonScalar']>;
  perPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type BlogPostItemsQuery = {
  __typename?: 'QueryType';
  BlogpostItems?: {
    __typename?: 'BlogpostItems';
    total?: number | null;
    items?: Array<{
      __typename?: 'BlogpostItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      published_at?: string | null;
      first_published_at?: string | null;
      content?: {
        __typename?: 'BlogpostComponent';
        synopsis?: string | null;
        title?: string | null;
        type?: string | null;
        category?: string | null;
        seo?: any | null;
        _uid?: string | null;
        _editable?: string | null;
        thumbnail?: {
          __typename?: 'Asset';
          alt?: string | null;
          filename: string;
        } | null;
      } | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type CareersOverviewItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type CareersOverviewItemQuery = {
  __typename?: 'QueryType';
  CareersoverviewItem?: {
    __typename?: 'CareersoverviewItem';
    uuid?: string | null;
    content?: {
      __typename?: 'CareersoverviewComponent';
      _editable?: string | null;
      _uid?: string | null;
      seo?: any | null;
      kicker?: string | null;
      title?: string | null;
      description?: string | null;
      button_text?: string | null;
      perks_title?: string | null;
      perks_kicker?: string | null;
      perks?: any | null;
      vacancies_title?: string | null;
      vacancies_kicker?: string | null;
      vacancies?: any | null;
      apply_button?: string | null;
      faq_kicker?: string | null;
      faq_title?: string | null;
      faq?: any | null;
      gallery?: Array<{
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
        id?: number | null;
      } | null> | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export type ContactItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type ContactItemQuery = {
  __typename?: 'QueryType';
  ContactItem?: {
    __typename?: 'ContactItem';
    uuid?: string | null;
    content?: {
      __typename?: 'ContactComponent';
      seo?: any | null;
      title?: string | null;
      description?: string | null;
      _editable?: string | null;
      _uid?: string | null;
      image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export type CookieBannerItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type CookieBannerItemQuery = {
  __typename?: 'QueryType';
  CookiebannerItem?: {
    __typename?: 'CookiebannerItem';
    uuid?: string | null;
    content?: {
      __typename?: 'CookiebannerComponent';
      component?: string | null;
      title?: string | null;
      text?: any | null;
      _editable?: string | null;
      _uid?: string | null;
    } | null;
  } | null;
};

export type CustomerOverviewItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: InputMaybe<Scalars['String']>;
}>;

export type CustomerOverviewItemQuery = {
  __typename?: 'QueryType';
  CustomeroverviewItem?: {
    __typename?: 'CustomeroverviewItem';
    full_slug?: string | null;
    default_full_slug?: string | null;
    uuid?: string | null;
    content?: {
      __typename?: 'CustomeroverviewComponent';
      _editable?: string | null;
      _uid?: string | null;
      seo?: any | null;
      kicker?: string | null;
      title?: string | null;
      subtitle?: string | null;
      button_text?: string | null;
      cta_text?: string | null;
      logo_section?: any | null;
      list_title?: string | null;
      cta_customers?: string | null;
      body?: any | null;
      featured_stories?: Array<{
        __typename?: 'Story';
        content?: any | null;
        fullSlug?: string | null;
        translatedSlugs?: Array<{
          __typename?: 'TranslatedSlug';
          lang: string;
          name?: string | null;
          path?: string | null;
        } | null> | null;
      } | null> | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type CustomerStoryItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: InputMaybe<Scalars['String']>;
}>;

export type CustomerStoryItemQuery = {
  __typename?: 'QueryType';
  CustomerstoryItem?: {
    __typename?: 'CustomerstoryItem';
    default_full_slug?: string | null;
    full_slug?: string | null;
    uuid?: string | null;
    content?: {
      __typename?: 'CustomerstoryComponent';
      _editable?: string | null;
      _uid?: string | null;
      component?: string | null;
      seo?: any | null;
      title?: string | null;
      header_text?: any | null;
      subtext?: any | null;
      summary?: any | null;
      body?: any | null;
      get_content?: string | null;
      manual_content?: any | null;
      logo?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      image_mobile?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      banner?: {
        __typename?: 'Story';
        content?: any | null;
        name?: string | null;
      } | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type CustomerStoryItemsQueryVariables = Exact<{
  by_slugs?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
}>;

export type CustomerStoryItemsQuery = {
  __typename?: 'QueryType';
  CustomerstoryItems?: {
    __typename?: 'CustomerstoryItems';
    items?: Array<{
      __typename?: 'CustomerstoryItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
      content?: {
        __typename?: 'CustomerstoryComponent';
        title?: string | null;
        synopsis?: string | null;
        overview_image?: {
          __typename?: 'Asset';
          alt?: string | null;
          filename: string;
        } | null;
        logo?: {
          __typename?: 'Asset';
          alt?: string | null;
          filename: string;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type DocsArticleItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type DocsArticleItemQuery = {
  __typename?: 'QueryType';
  DocsarticleItem?: {
    __typename?: 'DocsarticleItem';
    parent_id?: number | null;
    uuid?: string | null;
    content?: {
      __typename?: 'DocsarticleComponent';
      _editable?: string | null;
      _uid?: string | null;
      seo?: any | null;
      title?: string | null;
      subtext?: string | null;
      body?: any | null;
      component?: string | null;
      get_content?: string | null;
      manual_content?: any | null;
      bottom_links?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export type DocsArticleItemsQueryVariables = Exact<{
  by_slugs?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
}>;

export type DocsArticleItemsQuery = {
  __typename?: 'QueryType';
  DocsarticleItems?: {
    __typename?: 'DocsarticleItems';
    total?: number | null;
    items?: Array<{
      __typename?: 'DocsarticleItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      published_at?: string | null;
      first_published_at?: string | null;
      content?: {
        __typename?: 'DocsarticleComponent';
        title?: string | null;
        seo?: any | null;
        _uid?: string | null;
        _editable?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type DocsLandingItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type DocsLandingItemQuery = {
  __typename?: 'QueryType';
  DocslandingItem?: {
    __typename?: 'DocslandingItem';
    uuid?: string | null;
    content?: {
      __typename?: 'DocslandingComponent';
      _editable?: string | null;
      _uid?: string | null;
      seo?: any | null;
      cards?: any | null;
    } | null;
  } | null;
};

export type FooterItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type FooterItemQuery = {
  __typename?: 'QueryType';
  FooterItem?: {
    __typename?: 'FooterItem';
    uuid?: string | null;
    content?: {
      __typename?: 'FooterComponent';
      _editable?: string | null;
      _uid?: string | null;
      description?: string | null;
      component?: string | null;
      top_links?: any | null;
      link_columns?: any | null;
      bottom_links?: any | null;
      twitter?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      linkedin?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      github?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      instagram?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type GuideChapterItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type GuideChapterItemQuery = {
  __typename?: 'QueryType';
  GuidechapterItem?: {
    __typename?: 'GuidechapterItem';
    published_at?: string | null;
    default_full_slug?: string | null;
    full_slug?: string | null;
    uuid?: string | null;
    content?: {
      __typename?: 'GuidechapterComponent';
      _editable?: string | null;
      _uid?: string | null;
      component?: string | null;
      seo?: any | null;
      title?: string | null;
      body?: any | null;
      get_content?: string | null;
      manual_content?: any | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type GuideChapterItemsQueryVariables = Exact<{
  by_slugs?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
}>;

export type GuideChapterItemsQuery = {
  __typename?: 'QueryType';
  GuidechapterItems?: {
    __typename?: 'GuidechapterItems';
    items?: Array<{
      __typename?: 'GuidechapterItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
      content?: {
        __typename?: 'GuidechapterComponent';
        title?: string | null;
        short_title?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GuideIndexItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type GuideIndexItemQuery = {
  __typename?: 'QueryType';
  GuideindexItem?: {
    __typename?: 'GuideindexItem';
    default_full_slug?: string | null;
    full_slug?: string | null;
    published_at?: string | null;
    uuid?: string | null;
    content?: {
      __typename?: 'GuideindexComponent';
      component?: string | null;
      _editable?: string | null;
      _uid?: string | null;
      title?: string | null;
      body?: any | null;
      seo?: any | null;
      faq_kicker?: string | null;
      faq_title?: string | null;
      faq?: any | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type GuideIndexItemsQueryVariables = Exact<{
  filterId?: InputMaybe<Scalars['String']>;
  by_slugs?: InputMaybe<Scalars['String']>;
}>;

export type GuideIndexItemsQuery = {
  __typename?: 'QueryType';
  GuideindexItems?: {
    __typename?: 'GuideindexItems';
    items?: Array<{
      __typename?: 'GuideindexItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type HomeItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type HomeItemQuery = {
  __typename?: 'QueryType';
  HomeItem?: {
    __typename?: 'HomeItem';
    uuid?: string | null;
    content?: {
      __typename?: 'HomeComponent';
      title?: any | null;
      subtext?: string | null;
      button_1?: string | null;
      button_2?: string | null;
      feat_1?: string | null;
      feat_2?: string | null;
      logo_section?: any | null;
      text?: string | null;
      animation_1_title?: string | null;
      animation_1_description?: any | null;
      animation_2_title?: string | null;
      animation_2_description?: any | null;
      data_title?: any | null;
      data_subtitle?: string | null;
      data?: any | null;
      scroll_title?: any | null;
      scroll_subtitle?: string | null;
      scroll_cards?: any | null;
      customer_title?: any | null;
      customer_subtitle?: string | null;
      customer_results?: any | null;
      customer_button?: string | null;
      cards_title?: any | null;
      cards?: any | null;
      seo?: any | null;
      _editable?: string | null;
      _uid?: string | null;
      button_1_link?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      button_2_link?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      animation_1?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      animation_2?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      customer_image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      customer_logo?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      customer_link?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      banner_first?: { __typename?: 'Story'; content?: any | null } | null;
      banner_last?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export type IntegrationspageItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type IntegrationspageItemQuery = {
  __typename?: 'QueryType';
  IntegrationspageItem?: {
    __typename?: 'IntegrationspageItem';
    published_at?: string | null;
    uuid?: string | null;
    content?: {
      __typename?: 'IntegrationspageComponent';
      _editable?: string | null;
      _uid?: string | null;
      kicker?: string | null;
      title?: string | null;
      description?: string | null;
      button?: string | null;
      integrations?: any | null;
      banner?: {
        __typename?: 'Story';
        uuid?: string | null;
        content?: any | null;
      } | null;
    } | null;
  } | null;
};

export type LandingSettingsItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type LandingSettingsItemQuery = {
  __typename?: 'QueryType';
  LandingsettingsItem?: {
    __typename?: 'LandingsettingsItem';
    uuid?: string | null;
    content?: {
      __typename?: 'LandingsettingsComponent';
      component?: string | null;
      link_logo?: boolean | null;
      footer?: any | null;
      _editable?: string | null;
      _uid?: string | null;
    } | null;
  } | null;
};

export type NavigationItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type NavigationItemQuery = {
  __typename?: 'QueryType';
  NavigationItem?: {
    __typename?: 'NavigationItem';
    uuid?: string | null;
    content?: {
      __typename?: 'NavigationComponent';
      button_1_label?: string | null;
      button_2_label?: string | null;
      links?: any | null;
      component?: string | null;
      _editable?: string | null;
      _uid?: string | null;
      button_1_url?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      button_2_url?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type OnboardingItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type OnboardingItemQuery = {
  __typename?: 'QueryType';
  OnboardingItem?: {
    __typename?: 'OnboardingItem';
    uuid?: string | null;
    content?: {
      __typename?: 'OnboardingComponent';
      seo?: any | null;
      organisation_title?: string | null;
      organisation_question?: string | null;
      organisation_subtext?: string | null;
      organisation_placeholder?: string | null;
      organisation_features?: any | null;
      organisation_quote?: any | null;
      organisation_error?: any | null;
      usage_title?: string | null;
      usage_question?: string | null;
      usage_subtext?: string | null;
      role_title?: string | null;
      role_question?: string | null;
      role_subtext?: string | null;
      findus_title?: string | null;
      findus_question?: string | null;
      findus_subtext?: string | null;
      email_title?: string | null;
      email_question?: string | null;
      email_subtext?: string | null;
      email_placeholder?: string | null;
      marketing_comms?: string | null;
      privacy_policy?: any | null;
      submit_button?: string | null;
      success_title?: string | null;
      success_subtext?: string | null;
      success_button?: string | null;
      formType?: string | null;
      event?: string | null;
      _editable?: string | null;
      _uid?: string | null;
      success_button_link?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type PageItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type PageItemQuery = {
  __typename?: 'QueryType';
  PageItem?: {
    __typename?: 'PageItem';
    default_full_slug?: string | null;
    full_slug?: string | null;
    uuid?: string | null;
    content?: {
      __typename?: 'PageComponent';
      seo?: any | null;
      body?: any | null;
      component?: string | null;
      _editable?: string | null;
      _uid?: string | null;
      banner?: {
        __typename?: 'Story';
        content?: any | null;
        name?: string | null;
      } | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type PageItemsQueryVariables = Exact<{ [key: string]: never }>;

export type PageItemsQuery = {
  __typename?: 'QueryType';
  PageItems?: {
    __typename?: 'PageItems';
    items?: Array<{
      __typename?: 'PageItem';
      slug?: string | null;
      full_slug?: string | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type PartnerPageItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type PartnerPageItemQuery = {
  __typename?: 'QueryType';
  PartnerpageItem?: {
    __typename?: 'PartnerpageItem';
    uuid?: string | null;
    content?: {
      __typename?: 'PartnerpageComponent';
      seo?: any | null;
      scroll_panel?: any | null;
      logo_section?: any | null;
      title?: string | null;
      subtext?: string | null;
      button?: string | null;
      button_action?: string | null;
      button_2?: string | null;
      modal_form?: any | null;
      partner_form?: any | null;
      _uid?: string | null;
      _editable?: string | null;
      button_link?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      button_2_link?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      banner?: {
        __typename?: 'Story';
        content?: any | null;
        uuid?: string | null;
      } | null;
    } | null;
  } | null;
};

export type PressItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type PressItemQuery = {
  __typename?: 'QueryType';
  PressItem?: {
    __typename?: 'PressItem';
    uuid?: string | null;
    content?: {
      __typename?: 'PressComponent';
      seo?: any | null;
      kicker?: string | null;
      title?: string | null;
      subtext?: string | null;
      articles?: any | null;
      _editable?: string | null;
      _uid?: string | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export type PricingItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type PricingItemQuery = {
  __typename?: 'QueryType';
  PricingItem?: {
    __typename?: 'PricingItem';
    uuid?: string | null;
    content?: {
      __typename?: 'PricingComponent';
      seo?: any | null;
      title?: string | null;
      pricing_cards?: any | null;
      faq_kicker?: string | null;
      faq_title?: string | null;
      faq?: any | null;
      _editable?: string | null;
      _uid?: string | null;
      newsletter?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export type VacancyPageItemQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;

export type VacancyPageItemQuery = {
  __typename?: 'QueryType';
  VacancypageItem?: {
    __typename?: 'VacancypageItem';
    default_full_slug?: string | null;
    full_slug?: string | null;
    content?: {
      __typename?: 'VacancypageComponent';
      component?: string | null;
      seo?: any | null;
      title?: string | null;
      short?: string | null;
      keywords?: any | null;
      kicker?: string | null;
      body?: any | null;
      apply_box?: any | null;
      faq?: { __typename?: 'Story'; content?: any | null } | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type VacancyPageItemsQueryVariables = Exact<{
  filterId?: InputMaybe<Scalars['String']>;
}>;

export type VacancyPageItemsQuery = {
  __typename?: 'QueryType';
  VacancypageItems?: {
    __typename?: 'VacancypageItems';
    items?: Array<{
      __typename?: 'VacancypageItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      published_at?: string | null;
      content?: {
        __typename?: 'VacancypageComponent';
        title?: string | null;
        keywords?: any | null;
        _uid?: string | null;
      } | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type WebinarItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: InputMaybe<Scalars['String']>;
}>;

export type WebinarItemQuery = {
  __typename?: 'QueryType';
  WebinarItem?: {
    __typename?: 'WebinarItem';
    uuid?: string | null;
    full_slug?: string | null;
    default_full_slug?: string | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
    content?: {
      __typename?: 'WebinarComponent';
      _uid?: string | null;
      _editable?: string | null;
      seo?: any | null;
      kicker?: string | null;
      title?: string | null;
      date?: string | null;
      form_title?: string | null;
      form_subtext?: any | null;
      form_id?: string | null;
      form_success_title?: string | null;
      form_success_subtext?: string | null;
      button_text?: string | null;
      privacy_policy?: any | null;
      formType?: string | null;
      event?: string | null;
      about?: any | null;
      extra_info?: any | null;
      related_title?: string | null;
      image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      hosts?: Array<{
        __typename?: 'Story';
        content?: any | null;
      } | null> | null;
      related_events?: Array<{
        __typename?: 'Story';
        content?: any | null;
        slug?: string | null;
        fullSlug?: string | null;
        translatedSlugs?: Array<{
          __typename?: 'TranslatedSlug';
          lang: string;
          name?: string | null;
          path?: string | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type WebinarItemsQueryVariables = Exact<{
  filterId?: InputMaybe<Scalars['String']>;
  filterQuery?: InputMaybe<Scalars['JsonScalar']>;
  perPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  lang?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
}>;

export type WebinarItemsQuery = {
  __typename?: 'QueryType';
  WebinarItems?: {
    __typename?: 'WebinarItems';
    total?: number | null;
    items?: Array<{
      __typename?: 'WebinarItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      published_at?: string | null;
      first_published_at?: string | null;
      content?: {
        __typename?: 'WebinarComponent';
        kicker?: string | null;
        title?: string | null;
        date?: string | null;
        image?: {
          __typename?: 'Asset';
          alt?: string | null;
          filename: string;
        } | null;
        hosts?: Array<{
          __typename?: 'Story';
          content?: any | null;
        } | null> | null;
      } | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type WebinarOverviewItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: InputMaybe<Scalars['String']>;
}>;

export type WebinarOverviewItemQuery = {
  __typename?: 'QueryType';
  WebinaroverviewItem?: {
    __typename?: 'WebinaroverviewItem';
    full_slug?: string | null;
    default_full_slug?: string | null;
    uuid?: string | null;
    content?: {
      __typename?: 'WebinaroverviewComponent';
      _editable?: string | null;
      _uid?: string | null;
      kicker?: string | null;
      title?: string | null;
      subtitle?: string | null;
      button_text?: string | null;
      upcoming_title?: string | null;
      upcoming_cta?: string | null;
      highlight_subtext?: string | null;
      highlight_cta?: string | null;
      recorded_title?: string | null;
      body?: any | null;
      image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      highlight_image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      highlight?: {
        __typename?: 'Story';
        fullSlug?: string | null;
        content?: any | null;
      } | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type WebinarRecordedItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: InputMaybe<Scalars['String']>;
}>;

export type WebinarRecordedItemQuery = {
  __typename?: 'QueryType';
  WebinarrecordedItem?: {
    __typename?: 'WebinarrecordedItem';
    uuid?: string | null;
    full_slug?: string | null;
    default_full_slug?: string | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
    content?: {
      __typename?: 'WebinarrecordedComponent';
      _uid?: string | null;
      _editable?: string | null;
      seo?: any | null;
      title?: string | null;
      subtitle?: string | null;
      form?: any | null;
      label?: string | null;
      kicker?: string | null;
      about?: any | null;
      extra_info?: any | null;
      related_title?: string | null;
      body?: any | null;
      video?: {
        __typename?: 'Link';
        url: string;
        linktype: string;
        story?: { __typename?: 'Story'; fullSlug?: string | null } | null;
      } | null;
      image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      hosts?: Array<{
        __typename?: 'Story';
        content?: any | null;
      } | null> | null;
      related_events?: Array<{
        __typename?: 'Story';
        content?: any | null;
        slug?: string | null;
        fullSlug?: string | null;
        translatedSlugs?: Array<{
          __typename?: 'TranslatedSlug';
          lang: string;
          name?: string | null;
          path?: string | null;
        } | null> | null;
      } | null> | null;
      banner?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export type WebinarRecordedItemsQueryVariables = Exact<{
  filterId?: InputMaybe<Scalars['String']>;
  filterQuery?: InputMaybe<Scalars['JsonScalar']>;
  perPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  lang?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
}>;

export type WebinarRecordedItemsQuery = {
  __typename?: 'QueryType';
  WebinarrecordedItems?: {
    __typename?: 'WebinarrecordedItems';
    total?: number | null;
    items?: Array<{
      __typename?: 'WebinarrecordedItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      published_at?: string | null;
      first_published_at?: string | null;
      content?: {
        __typename?: 'WebinarrecordedComponent';
        title?: string | null;
        label?: string | null;
        hosts?: Array<{
          __typename?: 'Story';
          content?: any | null;
        } | null> | null;
        image?: {
          __typename?: 'Asset';
          alt?: string | null;
          filename: string;
        } | null;
      } | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type WhitepaperItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: InputMaybe<Scalars['String']>;
}>;

export type WhitepaperItemQuery = {
  __typename?: 'QueryType';
  WhitepaperItem?: {
    __typename?: 'WhitepaperItem';
    uuid?: string | null;
    full_slug?: string | null;
    default_full_slug?: string | null;
    content?: {
      __typename?: 'WhitepaperComponent';
      seo?: any | null;
      title?: string | null;
      subtitle?: string | null;
      form_id?: string | null;
      form_success_title?: string | null;
      form_success_subtext?: string | null;
      button_text?: string | null;
      privacy_policy?: any | null;
      formType?: string | null;
      event?: string | null;
      blocks?: any | null;
      _uid?: string | null;
      _editable?: string | null;
      bg_image?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
      thumbnail?: {
        __typename?: 'Asset';
        alt?: string | null;
        filename: string;
      } | null;
    } | null;
    translated_slugs?: Array<{
      __typename?: 'TranslatedSlug';
      lang: string;
      name?: string | null;
      path?: string | null;
    } | null> | null;
  } | null;
};

export type WhitepaperItemsQueryVariables = Exact<{
  filterId?: InputMaybe<Scalars['String']>;
  filterQuery?: InputMaybe<Scalars['JsonScalar']>;
  perPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  lang?: InputMaybe<Scalars['String']>;
  starts_with?: InputMaybe<Scalars['String']>;
}>;

export type WhitepaperItemsQuery = {
  __typename?: 'QueryType';
  WhitepaperItems?: {
    __typename?: 'WhitepaperItems';
    total?: number | null;
    items?: Array<{
      __typename?: 'WhitepaperItem';
      slug?: string | null;
      full_slug?: string | null;
      uuid?: string | null;
      published_at?: string | null;
      first_published_at?: string | null;
      content?: {
        __typename?: 'WhitepaperComponent';
        synopsis?: string | null;
        title?: string | null;
        _uid?: string | null;
        _editable?: string | null;
        thumbnail?: {
          __typename?: 'Asset';
          alt?: string | null;
          filename: string;
        } | null;
      } | null;
      translated_slugs?: Array<{
        __typename?: 'TranslatedSlug';
        lang: string;
        name?: string | null;
        path?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type WhitepaperOverviewItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: InputMaybe<Scalars['String']>;
}>;

export type WhitepaperOverviewItemQuery = {
  __typename?: 'QueryType';
  WhitepaperoverviewItem?: {
    __typename?: 'WhitepaperoverviewItem';
    uuid?: string | null;
    content?: {
      __typename?: 'WhitepaperoverviewComponent';
      _editable?: string | null;
      _uid?: string | null;
      seo?: any | null;
      title?: string | null;
      cta_text?: string | null;
      featured_whitepaper?: {
        __typename?: 'Story';
        content?: any | null;
        slug?: string | null;
        id?: number | null;
      } | null;
      banner_first?: { __typename?: 'Story'; content?: any | null } | null;
      banner_last?: { __typename?: 'Story'; content?: any | null } | null;
    } | null;
  } | null;
};

export const ImageFragmentFragmentDoc = gql`
  fragment ImageFragment on Asset {
    alt
    filename
  }
`;
export const LinkFragmentFragmentDoc = gql`
  fragment LinkFragment on Link {
    story {
      fullSlug
    }
    url
    linktype
  }
`;
export const TranslatedSlugsFragmentFragmentDoc = gql`
  fragment TranslatedSlugsFragment on TranslatedSlug {
    lang
    name
    path
  }
`;
export const AnnouncementBarItemDocument = gql`
  query announcementBarItem($slug: ID!) {
    AnnouncementbarItem(id: $slug, resolve_links: "url") {
      uuid
      content {
        text
        mobile_text
        link
        component
        _editable
        _uid
      }
    }
  }
`;
export const AuthorCardItemsDocument = gql`
  query authorCardItems($filterId: String) {
    AuthorcardItems(excluding_ids: $filterId) {
      items {
        content {
          name
          photo {
            ...ImageFragment
          }
          position
          _uid
        }
        uuid
      }
    }
  }
  ${ImageFragmentFragmentDoc}
`;
export const BlogOverviewItemDocument = gql`
  query blogOverviewItem($slug: ID!) {
    BlogoverviewItem(id: $slug, resolve_links: "url") {
      content {
        _editable
        _uid
        featured_post {
          content
          firstPublishedAt
          slug
          id
        }
        subtitle
        title
        latest_articles_title
        more_articles_title
        banner_first {
          content
        }
        banner_last {
          content
        }
        seo
      }
      uuid
    }
  }
`;
export const BlogPostItemDocument = gql`
  query blogPostItem($slug: ID!, $lang: String = "default") {
    BlogpostItem(
      id: $slug
      resolve_relations: "price_selector.price,newsletter_component.newsletter,author_card.author"
      resolve_links: "url"
    ) {
      content {
        component
        seo
        title
        thumbnail {
          ...ImageFragment
        }
        body
        author {
          content
        }
        banner(language: $lang) {
          content
        }
        related_articles {
          content
          slug
        }
        get_content
        manual_content
        _uid
        _editable
      }
      published_at
      first_published_at
      uuid
      default_full_slug
      full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
    }
  }
  ${ImageFragmentFragmentDoc}
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const BlogPostItemsDocument = gql`
  query blogPostItems(
    $filterId: String
    $filterQuery: JsonScalar
    $perPage: Int = 100
    $page: Int = 1
  ) {
    BlogpostItems(
      per_page: $perPage
      page: $page
      sort_by: "position:asc"
      excluding_ids: $filterId
      filter_query: $filterQuery
    ) {
      items {
        content {
          synopsis
          title
          thumbnail {
            ...ImageFragment
          }
          type
          category
          seo
          _uid
          _editable
        }
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
        uuid
        published_at
        first_published_at
      }
      total
    }
  }
  ${ImageFragmentFragmentDoc}
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const CareersOverviewItemDocument = gql`
  query careersOverviewItem($slug: ID!) {
    CareersoverviewItem(id: $slug, resolve_links: "url") {
      content {
        _editable
        _uid
        seo
        kicker
        title
        description
        button_text
        gallery {
          alt
          filename
          id
        }
        perks_title
        perks_kicker
        perks
        vacancies_title
        vacancies_kicker
        vacancies
        apply_button
        faq_kicker
        faq_title
        faq
        banner {
          content
        }
      }
      uuid
    }
  }
`;
export const ContactItemDocument = gql`
  query contactItem($slug: ID!) {
    ContactItem(id: $slug, resolve_links: "url") {
      content {
        seo
        title
        description
        image {
          ...ImageFragment
        }
        banner {
          content
        }
        _editable
        _uid
      }
      uuid
    }
  }
  ${ImageFragmentFragmentDoc}
`;
export const CookieBannerItemDocument = gql`
  query cookieBannerItem($slug: ID!) {
    CookiebannerItem(id: $slug) {
      uuid
      content {
        component
        title
        text
        _editable
        _uid
      }
    }
  }
`;
export const CustomerOverviewItemDocument = gql`
  query customerOverviewItem($slug: ID!, $lang: String = "default") {
    CustomeroverviewItem(id: $slug, resolve_links: "url", language: $lang) {
      content {
        _editable
        _uid
        seo
        kicker
        title
        subtitle
        button_text
        featured_stories {
          content
          fullSlug
          translatedSlugs {
            ...TranslatedSlugsFragment
          }
        }
        cta_text
        logo_section
        list_title
        cta_customers
        body
      }
      full_slug
      default_full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
      uuid
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const CustomerStoryItemDocument = gql`
  query customerStoryItem($slug: ID!, $lang: String = "default") {
    CustomerstoryItem(id: $slug, resolve_links: "url", language: $lang) {
      content {
        _editable
        _uid
        component
        seo
        title
        header_text
        logo {
          ...ImageFragment
        }
        image {
          ...ImageFragment
        }
        image_mobile {
          ...ImageFragment
        }
        subtext
        summary
        body
        get_content
        manual_content
        banner {
          content
          name
        }
      }
      default_full_slug
      full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
      uuid
    }
  }
  ${ImageFragmentFragmentDoc}
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const CustomerStoryItemsDocument = gql`
  query customerStoryItems(
    $by_slugs: String
    $lang: String = "default"
    $starts_with: String
  ) {
    CustomerstoryItems(
      per_page: 100
      by_slugs: $by_slugs
      language: $lang
      starts_with: $starts_with
    ) {
      items {
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
        content {
          title
          overview_image {
            ...ImageFragment
          }
          logo {
            ...ImageFragment
          }
          synopsis
        }
        uuid
      }
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
  ${ImageFragmentFragmentDoc}
`;
export const DocsArticleItemDocument = gql`
  query docsArticleItem($slug: ID!) {
    DocsarticleItem(id: $slug, resolve_links: "url") {
      content {
        _editable
        _uid
        seo
        title
        subtext
        body
        component
        get_content
        manual_content
        bottom_links {
          content
        }
      }
      parent_id
      uuid
    }
  }
`;
export const DocsArticleItemsDocument = gql`
  query docsArticleItems($by_slugs: String, $starts_with: String) {
    DocsarticleItems(
      per_page: 100
      by_slugs: $by_slugs
      starts_with: $starts_with
      sort_by: "position:asc"
    ) {
      items {
        content {
          title
          seo
          _uid
          _editable
        }
        slug
        full_slug
        uuid
        published_at
        first_published_at
      }
      total
    }
  }
`;
export const DocsLandingItemDocument = gql`
  query docsLandingItem($slug: ID!) {
    DocslandingItem(id: $slug, resolve_links: "url") {
      uuid
      content {
        _editable
        _uid
        seo
        cards
      }
    }
  }
`;
export const FooterItemDocument = gql`
  query footerItem($slug: ID!) {
    FooterItem(id: $slug, resolve_links: "url") {
      uuid
      content {
        _editable
        _uid
        description
        component
        top_links
        link_columns
        bottom_links
        twitter {
          ...LinkFragment
        }
        linkedin {
          ...LinkFragment
        }
        github {
          ...LinkFragment
        }
        instagram {
          ...LinkFragment
        }
      }
    }
  }
  ${LinkFragmentFragmentDoc}
`;
export const GuideChapterItemDocument = gql`
  query guideChapterItem($slug: ID!) {
    GuidechapterItem(id: $slug, resolve_links: "url") {
      content {
        _editable
        _uid
        component
        seo
        title
        body
        banner {
          content
        }
        get_content
        manual_content
      }
      published_at
      default_full_slug
      full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
      uuid
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const GuideChapterItemsDocument = gql`
  query guideChapterItems($by_slugs: String, $starts_with: String) {
    GuidechapterItems(
      per_page: 100
      by_slugs: $by_slugs
      starts_with: $starts_with
    ) {
      items {
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
        uuid
        content {
          title
          short_title
        }
      }
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const GuideIndexItemDocument = gql`
  query guideIndexItem($slug: ID!) {
    GuideindexItem(id: $slug, resolve_links: "url") {
      content {
        component
        _editable
        _uid
        title
        body
        seo
        faq_kicker
        faq_title
        faq
        banner {
          content
        }
      }
      default_full_slug
      full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
      published_at
      uuid
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const GuideIndexItemsDocument = gql`
  query guideIndexItems($filterId: String, $by_slugs: String) {
    GuideindexItems(
      per_page: 100
      sort_by: "published_at:desc"
      excluding_ids: $filterId
      by_slugs: $by_slugs
    ) {
      items {
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
        uuid
      }
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const HomeItemDocument = gql`
  query homeItem($slug: ID!) {
    HomeItem(id: $slug, resolve_links: "url") {
      content {
        title
        subtext
        button_1
        button_1_link {
          ...LinkFragment
        }
        button_2
        button_2_link {
          ...LinkFragment
        }
        feat_1
        feat_2
        image {
          ...ImageFragment
        }
        logo_section
        text
        animation_1_title
        animation_1_description
        animation_2_title
        animation_2_description
        animation_1 {
          ...ImageFragment
        }
        animation_2 {
          ...ImageFragment
        }
        data_title
        data_subtitle
        data
        scroll_title
        scroll_subtitle
        scroll_cards
        customer_title
        customer_subtitle
        customer_image {
          ...ImageFragment
        }
        customer_logo {
          ...ImageFragment
        }
        customer_results
        customer_button
        customer_link {
          ...LinkFragment
        }
        cards_title
        cards
        banner_first {
          content
        }
        banner_last {
          content
        }
        seo
        _editable
        _uid
      }
      uuid
    }
  }
  ${LinkFragmentFragmentDoc}
  ${ImageFragmentFragmentDoc}
`;
export const IntegrationspageItemDocument = gql`
  query integrationspageItem($slug: ID!) {
    IntegrationspageItem(id: $slug, resolve_links: "url") {
      content {
        _editable
        _uid
        kicker
        title
        description
        button
        integrations
        banner {
          uuid
          content
        }
      }
      published_at
      uuid
    }
  }
`;
export const LandingSettingsItemDocument = gql`
  query landingSettingsItem($slug: ID!) {
    LandingsettingsItem(id: $slug) {
      uuid
      content {
        component
        link_logo
        footer
        _editable
        _uid
      }
    }
  }
`;
export const NavigationItemDocument = gql`
  query navigationItem($slug: ID!) {
    NavigationItem(id: $slug, resolve_links: "url") {
      uuid
      content {
        button_1_label
        button_1_url {
          ...LinkFragment
        }
        button_2_label
        button_2_url {
          ...LinkFragment
        }
        links
        component
        _editable
        _uid
      }
    }
  }
  ${LinkFragmentFragmentDoc}
`;
export const OnboardingItemDocument = gql`
  query onboardingItem($slug: ID!) {
    OnboardingItem(id: $slug, resolve_links: "url") {
      uuid
      content {
        seo
        organisation_title
        organisation_question
        organisation_subtext
        organisation_placeholder
        organisation_features
        organisation_quote
        organisation_error
        usage_title
        usage_question
        usage_subtext
        role_title
        role_question
        role_subtext
        findus_title
        findus_question
        findus_subtext
        email_title
        email_question
        email_subtext
        email_placeholder
        marketing_comms
        privacy_policy
        submit_button
        success_title
        success_subtext
        success_button
        success_button_link {
          ...LinkFragment
        }
        formType
        event
        _editable
        _uid
      }
    }
  }
  ${LinkFragmentFragmentDoc}
`;
export const PageItemDocument = gql`
  query pageItem($slug: ID!) {
    PageItem(
      id: $slug
      resolve_relations: "newsletter_component.newsletter,team_section.team,team_section.founders,form.form"
      resolve_links: "url"
    ) {
      content {
        seo
        body
        banner {
          content
          name
        }
        component
        _editable
        _uid
      }
      default_full_slug
      full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
      uuid
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const PageItemsDocument = gql`
  query pageItems {
    PageItems(per_page: 100) {
      items {
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
      }
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const PartnerPageItemDocument = gql`
  query partnerPageItem($slug: ID!) {
    PartnerpageItem(
      id: $slug
      resolve_links: "url"
      resolve_relations: "feature_banner.banner"
    ) {
      content {
        seo
        scroll_panel
        logo_section
        title
        subtext
        button
        button_link {
          ...LinkFragment
        }
        button_action
        button_2
        button_2_link {
          ...LinkFragment
        }
        modal_form
        banner {
          content
          uuid
        }
        partner_form
        _uid
        _editable
      }
      uuid
    }
  }
  ${LinkFragmentFragmentDoc}
`;
export const PressItemDocument = gql`
  query pressItem($slug: ID!) {
    PressItem(id: $slug, resolve_links: "story") {
      content {
        seo
        kicker
        title
        subtext
        banner {
          content
        }
        articles
        _editable
        _uid
      }
      uuid
    }
  }
`;
export const PricingItemDocument = gql`
  query pricingItem($slug: ID!) {
    PricingItem(id: $slug, resolve_links: "url") {
      uuid
      content {
        seo
        title
        pricing_cards
        faq_kicker
        faq_title
        faq
        newsletter {
          content
        }
        _editable
        _uid
      }
    }
  }
`;
export const VacancyPageItemDocument = gql`
  query vacancyPageItem($slug: ID!) {
    VacancypageItem(id: $slug, resolve_links: "url") {
      content {
        component
        seo
        title
        short
        keywords
        kicker
        body
        apply_box
        faq {
          content
        }
        banner {
          content
        }
      }
      default_full_slug
      full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const VacancyPageItemsDocument = gql`
  query vacancyPageItems($filterId: String) {
    VacancypageItems(
      per_page: 100
      sort_by: "published_at:desc"
      excluding_ids: $filterId
    ) {
      items {
        content {
          title
          keywords
          _uid
        }
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
        uuid
        published_at
      }
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const WebinarItemDocument = gql`
  query webinarItem($slug: ID!, $lang: String = "default") {
    WebinarItem(id: $slug, resolve_links: "url", language: $lang) {
      uuid
      full_slug
      default_full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
      content {
        _uid
        _editable
        seo
        kicker
        title
        date
        image {
          ...ImageFragment
        }
        form_title
        form_subtext
        form_id
        form_success_title
        form_success_subtext
        button_text
        privacy_policy
        formType
        event
        about
        hosts {
          content
        }
        extra_info
        related_title
        related_events {
          content
          slug
          fullSlug
          translatedSlugs {
            ...TranslatedSlugsFragment
          }
        }
      }
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
  ${ImageFragmentFragmentDoc}
`;
export const WebinarItemsDocument = gql`
  query webinarItems(
    $filterId: String
    $filterQuery: JsonScalar
    $perPage: Int = 100
    $page: Int = 1
    $lang: String = "default"
    $starts_with: String
  ) {
    WebinarItems(
      per_page: $perPage
      page: $page
      sort_by: "position:asc"
      excluding_ids: $filterId
      filter_query: $filterQuery
      language: $lang
      starts_with: $starts_with
    ) {
      items {
        content {
          kicker
          title
          image {
            ...ImageFragment
          }
          hosts {
            content
          }
          date
        }
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
        uuid
        published_at
        first_published_at
      }
      total
    }
  }
  ${ImageFragmentFragmentDoc}
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const WebinarOverviewItemDocument = gql`
  query webinarOverviewItem($slug: ID!, $lang: String = "default") {
    WebinaroverviewItem(id: $slug, resolve_links: "url", language: $lang) {
      content {
        _editable
        _uid
        kicker
        title
        subtitle
        button_text
        image {
          ...ImageFragment
        }
        upcoming_title
        upcoming_cta
        highlight_image {
          ...ImageFragment
        }
        highlight {
          fullSlug
          content
        }
        highlight_subtext
        highlight_cta
        recorded_title
        body
        banner {
          content
        }
      }
      full_slug
      default_full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
      uuid
    }
  }
  ${ImageFragmentFragmentDoc}
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const WebinarRecordedItemDocument = gql`
  query webinarRecordedItem($slug: ID!, $lang: String = "default") {
    WebinarrecordedItem(id: $slug, resolve_links: "url", language: $lang) {
      uuid
      full_slug
      default_full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
      content {
        _uid
        _editable
        seo
        title
        subtitle
        video {
          ...LinkFragment
        }
        form
        image {
          ...ImageFragment
        }
        label
        kicker
        about
        hosts {
          content
        }
        extra_info
        related_title
        related_events {
          content
          slug
          fullSlug
          translatedSlugs {
            ...TranslatedSlugsFragment
          }
        }
        body
        banner {
          content
        }
      }
    }
  }
  ${TranslatedSlugsFragmentFragmentDoc}
  ${LinkFragmentFragmentDoc}
  ${ImageFragmentFragmentDoc}
`;
export const WebinarRecordedItemsDocument = gql`
  query webinarRecordedItems(
    $filterId: String
    $filterQuery: JsonScalar
    $perPage: Int = 100
    $page: Int = 1
    $lang: String = "default"
    $starts_with: String
  ) {
    WebinarrecordedItems(
      per_page: $perPage
      page: $page
      sort_by: "position:asc"
      excluding_ids: $filterId
      filter_query: $filterQuery
      language: $lang
      starts_with: $starts_with
    ) {
      items {
        content {
          title
          hosts {
            content
          }
          image {
            ...ImageFragment
          }
          label
        }
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
        uuid
        published_at
        first_published_at
      }
      total
    }
  }
  ${ImageFragmentFragmentDoc}
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const WhitepaperItemDocument = gql`
  query whitepaperItem($slug: ID!, $lang: String = "default") {
    WhitepaperItem(id: $slug, resolve_links: "url", language: $lang) {
      content {
        seo
        title
        subtitle
        bg_image {
          ...ImageFragment
        }
        thumbnail {
          ...ImageFragment
        }
        form_id
        form_success_title
        form_success_subtext
        button_text
        privacy_policy
        formType
        event
        blocks
        _uid
        _editable
      }
      uuid
      full_slug
      default_full_slug
      translated_slugs {
        ...TranslatedSlugsFragment
      }
    }
  }
  ${ImageFragmentFragmentDoc}
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const WhitepaperItemsDocument = gql`
  query whitepaperItems(
    $filterId: String
    $filterQuery: JsonScalar
    $perPage: Int = 100
    $page: Int = 1
    $lang: String = "default"
    $starts_with: String
  ) {
    WhitepaperItems(
      per_page: $perPage
      page: $page
      sort_by: "position:asc"
      excluding_ids: $filterId
      filter_query: $filterQuery
      language: $lang
      starts_with: $starts_with
    ) {
      items {
        content {
          synopsis
          title
          thumbnail {
            ...ImageFragment
          }
          _uid
          _editable
        }
        slug
        full_slug
        translated_slugs {
          ...TranslatedSlugsFragment
        }
        uuid
        published_at
        first_published_at
      }
      total
    }
  }
  ${ImageFragmentFragmentDoc}
  ${TranslatedSlugsFragmentFragmentDoc}
`;
export const WhitepaperOverviewItemDocument = gql`
  query whitepaperOverviewItem($slug: ID!, $lang: String = "default") {
    WhitepaperoverviewItem(id: $slug, resolve_links: "url", language: $lang) {
      content {
        _editable
        _uid
        seo
        title
        cta_text
        featured_whitepaper(language: $lang) {
          content
          slug
          id
        }
        banner_first(language: $lang) {
          content
        }
        banner_last(language: $lang) {
          content
        }
      }
      uuid
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    announcementBarItem(
      variables: AnnouncementBarItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<AnnouncementBarItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AnnouncementBarItemQuery>(
            AnnouncementBarItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'announcementBarItem',
        'query',
      );
    },
    authorCardItems(
      variables?: AuthorCardItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<AuthorCardItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AuthorCardItemsQuery>(
            AuthorCardItemsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'authorCardItems',
        'query',
      );
    },
    blogOverviewItem(
      variables: BlogOverviewItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<BlogOverviewItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<BlogOverviewItemQuery>(
            BlogOverviewItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'blogOverviewItem',
        'query',
      );
    },
    blogPostItem(
      variables: BlogPostItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<BlogPostItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<BlogPostItemQuery>(BlogPostItemDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'blogPostItem',
        'query',
      );
    },
    blogPostItems(
      variables?: BlogPostItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<BlogPostItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<BlogPostItemsQuery>(BlogPostItemsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'blogPostItems',
        'query',
      );
    },
    careersOverviewItem(
      variables: CareersOverviewItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CareersOverviewItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CareersOverviewItemQuery>(
            CareersOverviewItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'careersOverviewItem',
        'query',
      );
    },
    contactItem(
      variables: ContactItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<ContactItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ContactItemQuery>(ContactItemDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'contactItem',
        'query',
      );
    },
    cookieBannerItem(
      variables: CookieBannerItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CookieBannerItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CookieBannerItemQuery>(
            CookieBannerItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'cookieBannerItem',
        'query',
      );
    },
    customerOverviewItem(
      variables: CustomerOverviewItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CustomerOverviewItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustomerOverviewItemQuery>(
            CustomerOverviewItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'customerOverviewItem',
        'query',
      );
    },
    customerStoryItem(
      variables: CustomerStoryItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CustomerStoryItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustomerStoryItemQuery>(
            CustomerStoryItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'customerStoryItem',
        'query',
      );
    },
    customerStoryItems(
      variables?: CustomerStoryItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<CustomerStoryItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustomerStoryItemsQuery>(
            CustomerStoryItemsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'customerStoryItems',
        'query',
      );
    },
    docsArticleItem(
      variables: DocsArticleItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<DocsArticleItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DocsArticleItemQuery>(
            DocsArticleItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'docsArticleItem',
        'query',
      );
    },
    docsArticleItems(
      variables?: DocsArticleItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<DocsArticleItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DocsArticleItemsQuery>(
            DocsArticleItemsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'docsArticleItems',
        'query',
      );
    },
    docsLandingItem(
      variables: DocsLandingItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<DocsLandingItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DocsLandingItemQuery>(
            DocsLandingItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'docsLandingItem',
        'query',
      );
    },
    footerItem(
      variables: FooterItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<FooterItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FooterItemQuery>(FooterItemDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'footerItem',
        'query',
      );
    },
    guideChapterItem(
      variables: GuideChapterItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<GuideChapterItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GuideChapterItemQuery>(
            GuideChapterItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'guideChapterItem',
        'query',
      );
    },
    guideChapterItems(
      variables?: GuideChapterItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<GuideChapterItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GuideChapterItemsQuery>(
            GuideChapterItemsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'guideChapterItems',
        'query',
      );
    },
    guideIndexItem(
      variables: GuideIndexItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<GuideIndexItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GuideIndexItemQuery>(
            GuideIndexItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'guideIndexItem',
        'query',
      );
    },
    guideIndexItems(
      variables?: GuideIndexItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<GuideIndexItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GuideIndexItemsQuery>(
            GuideIndexItemsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'guideIndexItems',
        'query',
      );
    },
    homeItem(
      variables: HomeItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<HomeItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<HomeItemQuery>(HomeItemDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'homeItem',
        'query',
      );
    },
    integrationspageItem(
      variables: IntegrationspageItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<IntegrationspageItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IntegrationspageItemQuery>(
            IntegrationspageItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'integrationspageItem',
        'query',
      );
    },
    landingSettingsItem(
      variables: LandingSettingsItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<LandingSettingsItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LandingSettingsItemQuery>(
            LandingSettingsItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'landingSettingsItem',
        'query',
      );
    },
    navigationItem(
      variables: NavigationItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<NavigationItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<NavigationItemQuery>(
            NavigationItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'navigationItem',
        'query',
      );
    },
    onboardingItem(
      variables: OnboardingItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<OnboardingItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OnboardingItemQuery>(
            OnboardingItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'onboardingItem',
        'query',
      );
    },
    pageItem(
      variables: PageItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<PageItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PageItemQuery>(PageItemDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'pageItem',
        'query',
      );
    },
    pageItems(
      variables?: PageItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<PageItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PageItemsQuery>(PageItemsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'pageItems',
        'query',
      );
    },
    partnerPageItem(
      variables: PartnerPageItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<PartnerPageItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PartnerPageItemQuery>(
            PartnerPageItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'partnerPageItem',
        'query',
      );
    },
    pressItem(
      variables: PressItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<PressItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PressItemQuery>(PressItemDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'pressItem',
        'query',
      );
    },
    pricingItem(
      variables: PricingItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<PricingItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PricingItemQuery>(PricingItemDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'pricingItem',
        'query',
      );
    },
    vacancyPageItem(
      variables: VacancyPageItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<VacancyPageItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<VacancyPageItemQuery>(
            VacancyPageItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'vacancyPageItem',
        'query',
      );
    },
    vacancyPageItems(
      variables?: VacancyPageItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<VacancyPageItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<VacancyPageItemsQuery>(
            VacancyPageItemsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'vacancyPageItems',
        'query',
      );
    },
    webinarItem(
      variables: WebinarItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<WebinarItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WebinarItemQuery>(WebinarItemDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'webinarItem',
        'query',
      );
    },
    webinarItems(
      variables?: WebinarItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<WebinarItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WebinarItemsQuery>(WebinarItemsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'webinarItems',
        'query',
      );
    },
    webinarOverviewItem(
      variables: WebinarOverviewItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<WebinarOverviewItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WebinarOverviewItemQuery>(
            WebinarOverviewItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'webinarOverviewItem',
        'query',
      );
    },
    webinarRecordedItem(
      variables: WebinarRecordedItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<WebinarRecordedItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WebinarRecordedItemQuery>(
            WebinarRecordedItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'webinarRecordedItem',
        'query',
      );
    },
    webinarRecordedItems(
      variables?: WebinarRecordedItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<WebinarRecordedItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WebinarRecordedItemsQuery>(
            WebinarRecordedItemsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'webinarRecordedItems',
        'query',
      );
    },
    whitepaperItem(
      variables: WhitepaperItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<WhitepaperItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WhitepaperItemQuery>(
            WhitepaperItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'whitepaperItem',
        'query',
      );
    },
    whitepaperItems(
      variables?: WhitepaperItemsQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<WhitepaperItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WhitepaperItemsQuery>(
            WhitepaperItemsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'whitepaperItems',
        'query',
      );
    },
    whitepaperOverviewItem(
      variables: WhitepaperOverviewItemQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<WhitepaperOverviewItemQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<WhitepaperOverviewItemQuery>(
            WhitepaperOverviewItemDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'whitepaperOverviewItem',
        'query',
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
